import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { CtaButton } from './ui/CtaButton';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-night-deep px-5 py-20" aria-labelledby="faq-titulo" data-id="element-36" data-mp="1bmllj4fjvriw">
      <div className="mx-auto max-w-3xl" data-id="element-37" data-mp="1gk57kqihp8le">
        <h2 id="faq-titulo" className="text-center font-display text-2xl font-bold text-cream md:text-4xl" data-id="element-38" data-mp="249g41vst4gtq">
          Preguntas frecuentes
        </h2>

        <ul className="mt-12 space-y-3" data-id="element-39" data-mp="28a9titlwe3oq">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-lg border border-night-line bg-night-soft" data-id="element-40" data-mp="1zhy2b5iymc7p" data-mpi={index}>
                <h3 data-id="element-41" data-mp="2n7sh3smuaaul">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-base font-semibold text-cream transition-colors duration-150 ease-out hover:text-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold" data-id="element-42" data-mp="2n6hazm5x8r0b">
                    {faq.question}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-43" data-mp="1ohq3laa63f2b" />
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5 text-sm leading-relaxed text-cream-dim md:text-base" data-id="element-44" data-mp="35eyw2zvw53p">
                    {faq.answer}
                  </div>}
              </li>;
        })}
        </ul>

        <div className="mt-12 text-center" data-id="element-45" data-mp="1yaxwbda83u5z">
          <CtaButton data-id="element-46" data-mp="237o9nsun8bnp">Quiero acceder a los mapas 3D</CtaButton>
        </div>
      </div>
    </section>;
}